import { render, staticRenderFns } from "./GlbAnchorCalibration.vue?vue&type=template&id=0b3504d6&scoped=true"
import script from "./GlbAnchorCalibration.vue?vue&type=script&lang=js"
export * from "./GlbAnchorCalibration.vue?vue&type=script&lang=js"
import style0 from "./GlbAnchorCalibration.vue?vue&type=style&index=0&id=0b3504d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3504d6",
  null
  
)

export default component.exports